module.exports = __webpack_public_path__ + "static/media/ic_info.a34fb1de.svg";